module.exports = __webpack_public_path__ + "img/dots-vertical.632f0a93.svg";